






import React from "react"
import { MyNav } from "./mynavbar/mynavbar"
const gumroad = window.GUMROAD
const container = React.createRef()

export class BuyNUNISYNTH extends React.Component {

    componentDidMount() {
        // gumroad.style.display = "block"
        gumroad.style.position = 'static'
        gumroad.style.pointerEvents = 'all'
        gumroad.style.opacity = '1'
        
        container.current.appendChild(gumroad)
    }

    render() {
        return <div>
            <MyNav no_buy_button/>
            <div ref={container}></div>
        </div>
    }
}